import { Storage } from "@dashboard-v3/api";

export const allowedStorages = ["BOX", "EGNYTE"] as const;

export default function canUseTemplate(provider: Storage["provider"]) {
  return ["BOX", "EGNYTE", "EGNYTE_GOV"].includes(provider as AllowedStorage);
}

export type AllowedStorage = (typeof allowedStorages)[number];
